import { render } from "./PdfExtractionInsertModal.vue?vue&type=template&id=552401c4&scoped=true"
import script from "./PdfExtractionInsertModal.vue?vue&type=script&lang=js"
export * from "./PdfExtractionInsertModal.vue?vue&type=script&lang=js"

import "./PdfExtractionInsertModal.vue?vue&type=style&index=0&id=552401c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552401c4"]])

export default __exports__